import axios from 'axios'

////////////////////////////////////////////////////////////////////////////////
// Initialize Axios
////////////////////////////////////////////////////////////////////////////////

export function get(url, params) {
  log.trace(`API GET:${url}`, params || 'No querystring params')

  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      params
    })
      .then(response => {
        log.trace(`API GET:${url} -> Success`, response)

        resolve(response.data, response)
      })
      .catch(error => {
        log.trace(`API GET:${url} -> Failure`, error)

        reject(error)
      })
  })
}

export function post(url, data) {
  log.trace(`API POST:${url}`, data || 'No data')

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      data
    })
      .then(response => {
        log.trace(`API POST:${url} -> Success`, response)

        resolve(response.data, response)
      })
      .catch(error => {
        log.trace(`API POST:${url} -> Failure`, error)

        reject(error)
      })
  })
}
